import React from 'react'
import { Link, useLocation } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { 
  HomeIcon, 
  CubeIcon, 
  ShoppingCartIcon, 
  CogIcon,
  TagIcon,
  ShieldCheckIcon,
  UserGroupIcon,
  WrenchScrewdriverIcon,
  SparklesIcon,
  CurrencyDollarIcon
} from '@heroicons/react/24/outline'

export const Navigation: React.FC = () => {
  const { t } = useTranslation()
  const location = useLocation()

  const navigation = [
    { name: t('navigation.dashboard'), href: '/', icon: HomeIcon },
    { name: t('navigation.inventory'), href: '/inventory', icon: CubeIcon },
    { name: t('navigation.market'), href: '/market', icon: ShoppingCartIcon },
    { name: t('navigation.production'), href: '/production', icon: CogIcon },
    { name: t('navigation.brands'), href: '/brands', icon: TagIcon },
    { name: t('navigation.copyright'), href: '/copyright', icon: ShieldCheckIcon },
    { name: t('navigation.employees'), href: '/employees', icon: UserGroupIcon },
    { name: t('navigation.machinery'), href: '/machinery', icon: WrenchScrewdriverIcon },
    { name: t('navigation.productRequests'), href: '/product-requests', icon: SparklesIcon },
    { name: t('navigation.cryptoWallet'), href: '/crypto-wallet', icon: CurrencyDollarIcon },
  ]

  return (
    <nav className="w-64 bg-white shadow-lg">
      <div className="p-6">
        <h1 className="text-2xl font-bold text-gray-800 mb-8">
          🏢 {t('navigation.gameTitle')}
        </h1>
        <ul className="space-y-2">
          {navigation.map((item) => {
            const isActive = location.pathname === item.href
            return (
              <li key={item.name}>
                <Link
                  to={item.href}
                  className={`flex items-center px-4 py-3 rounded-lg transition-colors duration-200 ${
                    isActive
                      ? 'bg-blue-100 text-blue-700 font-medium'
                      : 'text-gray-600 hover:bg-gray-100 hover:text-gray-900'
                  }`}
                >
                  <item.icon className="w-5 h-5 ml-3" />
                  {item.name}
                </Link>
              </li>
            )
          })}
        </ul>
      </div>
    </nav>
  )
}
